import { render, staticRenderFns } from "./FilterSettings.vue?vue&type=template&id=45d659da"
import script from "./FilterSettings.vue?vue&type=script&lang=js"
export * from "./FilterSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports